/* ==========================================================================
   Dynoforce shopfilters zonder herladen

   De filterbalk zette een vinkje om in een nieuw adres en liet de browser de
   hele pagina opnieuw laden. Dat kost een seconde, en erger: je staat weer
   bovenaan terwijl je net bij het grid keek. Hier vangen we die acties op en
   halen alleen de twee secties op die echt veranderen - de filterbalk (de
   aantallen en de actieve staat lopen mee) en het productgrid.

   Dat gaat via de sectie-route van Shopify: dezelfde url met ?sections=<id>
   geeft de gerenderde html van die secties terug. Dus geen tweede weergave in
   JavaScript die uit de pas kan lopen met de Liquid: het is dezelfde sectie,
   alleen dan zonder de rest van de pagina eromheen.

   Werkt JavaScript niet, of gaat de opvraging mis, dan blijft alles zoals het
   was: de balk staat in een gewoon <form method="get"> met echte links, en bij
   een fout sturen we de browser alsnog gewoon naar dat adres.

   De uitklappers, het zoekveld binnen een filter en het sluiten met Escape
   zaten eerst in een script in de sectie zelf. Dat werkt hier niet meer: zodra
   we de balk vervangen is dat script zijn elementen kwijt. Daarom staat alles
   nu op document met gedelegeerde luisteraars, die een vervanging overleven.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__dfShopAjax) return;
  window.__dfShopAjax = true;

  var BREED = window.matchMedia('(min-width:768px)');
  var RUSTIG = window.matchMedia('(prefers-reduced-motion: reduce)');

  function balk() { return document.querySelector('[data-df-fb]'); }
  function grid() { return document.querySelector('[data-df-grid]'); }
  function sectieVan(el) { return el ? el.getAttribute('data-df-sectie') : null; }

  /* De knoppen "Toon resultaten" horen alleen te staan als JavaScript uit is.
     De sectie zet deze klasse zelf al bij het inladen; hier zetten we hem
     terug na elke vervanging. */
  function merkJs() {
    var b = balk();
    if (b) b.classList.add('df-fb--js');
  }

  /* ---------- uitklappers ---------- */

  function groepen() {
    var b = balk();
    return b ? Array.prototype.slice.call(b.querySelectorAll('.df-fb__grp')) : [];
  }

  function sluitAlles(behalve) {
    groepen().forEach(function (g) { if (g !== behalve) g.open = false; });
  }

  /* toggle bubbelt niet, dus opvangen in de capture-fase. */
  document.addEventListener('toggle', function (e) {
    var g = e.target;
    if (!g || !g.classList || !g.classList.contains('df-fb__grp')) return;
    if (g.open && BREED.matches) sluitAlles(g);
  }, true);

  document.addEventListener('click', function (e) {
    var b = balk();
    if (!b || b.contains(e.target)) return;
    if (!BREED.matches) return;
    sluitAlles(null);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') sluitAlles(null);
  });

  /* Zoeken binnen een lange lijst. Alleen tonen wat past; blijft er niets
     over, dan komt de regel Niets gevonden tevoorschijn. Puur cosmetisch, de
     vinkjes eronder blijven staan waar ze staan. */
  document.addEventListener('input', function (e) {
    var veld = e.target;
    if (!veld || !veld.hasAttribute || !veld.hasAttribute('data-df-zoek')) return;
    var pop = veld.closest('.df-fb__pop');
    if (!pop) return;
    var t = veld.value.trim().toLowerCase();
    var over = 0;
    Array.prototype.forEach.call(pop.querySelectorAll('.df-fb__opt'), function (o) {
      var raak = t === '' || o.textContent.toLowerCase().indexOf(t) !== -1;
      o.classList.toggle('df-fb__opt--weg', !raak);
      if (raak) over++;
    });
    var niks = pop.querySelector('[data-df-niks]');
    if (niks) niks.style.display = over === 0 ? 'block' : 'none';
  });

  /* ---------- prijs met een schuifbalk ----------
     De twee getalvakken blijven staan: zonder JavaScript zijn zij het filter,
     en wie een exact bedrag weet tikt dat sneller in dan hij het schuift. De
     balk erboven schrijft in diezelfde vakken, dus er is maar een waarheid.

     De stand loopt van 0 tot 1000 en is niet hetzelfde als het bedrag. Het
     bereik in deze shop loopt tot 48.400 euro terwijl de helft van de
     artikelen onder de 700 zit; recht verdeeld zou alles wat de bezoeker
     zoekt in de eerste centimeter geplet zitten. De sectie geeft daarom een
     macht mee: bij een breed bereik staat de helft van de balk op vijf
     procent van het hoogste bedrag. Bij een smal bereik is de macht een en is
     de balk gewoon recht.

     De bedragen worden afgerond op iets leesbaars - per vijf onderin, per
     tweehonderdvijftig bovenin - want een filter op 4.237 euro zegt niemand
     iets.

     Slepen doen we zelf. Twee bereikvelden over elkaar heen betekent dat de
     bovenste greep de onderste afdekt zodra ze bij elkaar staan, en dan zit
     je vast. Daarom vangen de velden zelf niets op (pointer-events staat uit
     in de sectie) en kijken we bij het aanraken welke greep het dichtst bij
     ligt. Ligt de aanraking buiten beide grepen, dan pakken we de greep aan
     die kant - zo werkt een tik op de baan ook gewoon. Pijltjestoetsen blijven
     wel gewoon van de velden zelf. */

  function schuifVan(el) {
    return (el && el.closest) ? el.closest('[data-df-sch]') : null;
  }
  function grepen(sch) {
    return { lo: sch.querySelector('[data-df-sch-veld="min"]'),
             hi: sch.querySelector('[data-df-sch-veld="max"]') };
  }
  function vakken(sch) {
    var pop = sch.closest('.df-fb__pop') || sch.parentNode;
    return { lo: pop.querySelector('[data-df-prijs="min"]'),
             hi: pop.querySelector('[data-df-prijs="max"]') };
  }
  function afronden(v) {
    if (v <= 100) return Math.round(v / 5) * 5;
    if (v <= 1000) return Math.round(v / 25) * 25;
    if (v <= 5000) return Math.round(v / 50) * 50;
    return Math.round(v / 250) * 250;
  }
  function naarEuro(stand, max, macht) {
    /* Nooit boven het hoogste bedrag uitkomen: afronden gaat per 250 en zou
       er anders overheen schieten, en dan staat er een bedrag in het vak dat
       het getalveld zelf al te hoog vindt. */
    return Math.min(max, afronden(max * Math.pow(stand / 1000, macht)));
  }
  function naarStand(euro, max, macht) {
    if (!(max > 0)) return 0;
    var deel = Math.max(0, Math.min(1, euro / max));
    return Math.round(1000 * Math.pow(deel, 1 / macht));
  }
  function geld(n) {
    try { return '\u20ac ' + n.toLocaleString(); } catch (e) { return '\u20ac ' + n; }
  }

  /* Alleen de baan en de voorleestekst; de getalvakken blijven zoals ze zijn.
     Dat laatste is nodig terwijl iemand in zo'n vak staat te typen: wie "1"
     intikt zou anders meteen een afgerond bedrag terugkrijgen. */
  function tekenBaan(sch) {
    var g = grepen(sch);
    if (!g.lo || !g.hi) return;
    var max = parseFloat(sch.getAttribute('data-max')) || 0;
    var macht = parseFloat(sch.getAttribute('data-macht')) || 1;
    var lo = parseInt(g.lo.value, 10) || 0;
    var hi = parseInt(g.hi.value, 10);
    if (isNaN(hi)) hi = 1000;
    var vul = sch.querySelector('[data-df-sch-vul]');
    if (vul) {
      vul.style.left = (lo / 10) + '%';
      vul.style.right = (100 - hi / 10) + '%';
    }
    g.lo.setAttribute('aria-valuetext', geld(naarEuro(lo, max, macht)));
    g.hi.setAttribute('aria-valuetext', geld(hi >= 1000 ? max : naarEuro(hi, max, macht)));
  }

  /* En hier wel de vakken mee. Een greep helemaal links of helemaal rechts
     betekent geen grens: het vak blijft leeg, gaat niet mee in het adres en
     laat zijn plaatshouder zien. */
  function teken(sch) {
    tekenBaan(sch);
    var g = grepen(sch), vak = vakken(sch);
    if (!g.lo || !g.hi) return;
    var max = parseFloat(sch.getAttribute('data-max')) || 0;
    var macht = parseFloat(sch.getAttribute('data-macht')) || 1;
    var lo = parseInt(g.lo.value, 10) || 0;
    var hi = parseInt(g.hi.value, 10);
    if (isNaN(hi)) hi = 1000;
    if (vak.lo) vak.lo.value = lo <= 0 ? '' : String(naarEuro(lo, max, macht));
    if (vak.hi) vak.hi.value = hi >= 1000 ? '' : String(naarEuro(hi, max, macht));
  }

  function zetGreep(sch, greep, stand) {
    var g = grepen(sch);
    if (!g.lo || !g.hi) return;
    if (greep === g.lo) stand = Math.min(stand, parseInt(g.hi.value, 10));
    else stand = Math.max(stand, parseInt(g.lo.value, 10));
    greep.value = Math.max(0, Math.min(1000, stand));
    teken(sch);
  }

  function standUitX(sch, x) {
    var baan = sch.querySelector('.df-fb__sch-baan');
    var r = (baan || sch).getBoundingClientRect();
    if (!r.width) return 0;
    return Math.max(0, Math.min(1000, Math.round((x - r.left) / r.width * 1000)));
  }

  /* De vakken zijn leidend bij het inladen en na elke vervanging: de sectie
     rendert de grepen altijd op wijd open en zet er geen stand in, want die
     stand hangt van de macht af en dat rekent Liquid niet. */
  function uitVakken(sch) {
    var g = grepen(sch), vak = vakken(sch);
    if (!g.lo || !g.hi) return;
    var max = parseFloat(sch.getAttribute('data-max')) || 0;
    var macht = parseFloat(sch.getAttribute('data-macht')) || 1;
    var lo = (vak.lo && vak.lo.value !== '') ? naarStand(parseFloat(vak.lo.value), max, macht) : 0;
    var hi = (vak.hi && vak.hi.value !== '') ? naarStand(parseFloat(vak.hi.value), max, macht) : 1000;
    if (lo > hi) lo = hi;
    g.lo.value = lo;
    g.hi.value = hi;
    tekenBaan(sch);
  }

  function schuiven() {
    var b = balk();
    return b ? Array.prototype.slice.call(b.querySelectorAll('[data-df-sch]')) : [];
  }
  function stelSchuivenIn() {
    schuiven().forEach(uitVakken);
  }

  /* Loslaten is het gebaar dat zegt: zo wil ik het. Toch even wachten, want
     met de pijltjestoetsen komt er per aanslag een change langs en dan zou
     elke tik een opvraging worden. Is er niets veranderd aan wat er al in het
     adres staat, dan gebeurt er niets. */
  var prijsWacht = null;
  function pasPrijsToe(sch) {
    if (prijsWacht) clearTimeout(prijsWacht);
    prijsWacht = setTimeout(function () {
      prijsWacht = null;
      var vak = vakken(sch);
      if (!vak.lo || !vak.hi) return;
      var u = new URL(window.location.href);
      if ((u.searchParams.get(vak.lo.name) || '') === vak.lo.value &&
          (u.searchParams.get(vak.hi.name) || '') === vak.hi.value) return;
      var form = sch.closest('form');
      if (form) form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }, 350);
  }

  var sleept = null;

  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType === 'mouse' && e.button !== 0) return;
    var sch = schuifVan(e.target);
    if (!sch) return;
    var g = grepen(sch);
    if (!g.lo || !g.hi) return;
    var stand = standUitX(sch, e.clientX);
    var lo = parseInt(g.lo.value, 10) || 0;
    var hi = parseInt(g.hi.value, 10);
    if (isNaN(hi)) hi = 1000;
    var pak;
    if (stand <= lo) pak = g.lo;
    else if (stand >= hi) pak = g.hi;
    else pak = (stand - lo <= hi - stand) ? g.lo : g.hi;
    sleept = { sch: sch, greep: pak };
    try { sch.setPointerCapture(e.pointerId); } catch (er) { /* oudere browser */ }
    e.preventDefault();
    zetGreep(sch, pak, stand);
    try { pak.focus({ preventScroll: true }); } catch (er) { /* laat maar */ }
  });

  document.addEventListener('pointermove', function (e) {
    if (!sleept) return;
    zetGreep(sleept.sch, sleept.greep, standUitX(sleept.sch, e.clientX));
  });

  function losLaten() {
    if (!sleept) return;
    var sch = sleept.sch;
    sleept = null;
    pasPrijsToe(sch);
  }
  document.addEventListener('pointerup', losLaten);
  document.addEventListener('pointercancel', losLaten);

  /* Pijltjestoetsen komen wel gewoon bij het veld zelf binnen. */
  document.addEventListener('input', function (e) {
    var el = e.target;
    if (!el || !el.getAttribute) return;
    if (el.getAttribute('data-df-sch-veld')) {
      var sch = schuifVan(el);
      if (sch) zetGreep(sch, el, parseInt(el.value, 10) || 0);
      return;
    }
    if (el.getAttribute('data-df-prijs')) {
      var sch2 = null;
      var pop = el.closest ? el.closest('.df-fb__pop') : null;
      if (pop) sch2 = pop.querySelector('[data-df-sch]');
      if (sch2) uitVakken(sch2);
    }
  });

  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el || !el.getAttribute || !el.getAttribute('data-df-sch-veld')) return;
    var sch = schuifVan(el);
    if (sch) pasPrijsToe(sch);
  });

  /* ---------- stand van de balk bewaren over een vervanging heen ----------
     Wie drie merken aanvinkt wil niet dat de uitklapper na het eerste vinkje
     dichtklapt. We onthouden dus welk filter openstond, hoe ver de lijst
     gescrold was en welk vakje de aandacht had, en zetten dat terug. Het
     label van de uitklapper is de sleutel; het aantal erachter verandert
     namelijk juist wel. */

  function labelVan(g) {
    var sum = g.querySelector('summary');
    if (!sum) return '';
    var knoop = sum.firstChild;
    while (knoop && knoop.nodeType !== 3) knoop = knoop.nextSibling;
    return (knoop ? knoop.textContent : sum.textContent).trim();
  }

  function standNu() {
    var b = balk();
    if (!b) return null;
    var s = { label: null, scroll: 0, vink: null, zoek: null, greep: null };
    var open = b.querySelector('.df-fb__grp[open]');
    if (open) {
      s.label = labelVan(open);
      var lijst = open.querySelector('.df-fb__lijst');
      if (lijst) s.scroll = lijst.scrollTop;
      var zoek = open.querySelector('[data-df-zoek]');
      if (zoek && zoek.value) s.zoek = zoek.value;
    }
    var nu = document.activeElement;
    if (nu && nu.type === 'checkbox' && b.contains(nu)) {
      s.vink = { naam: nu.name, waarde: nu.value };
    }
    if (nu && nu.getAttribute && b.contains(nu) && nu.getAttribute('data-df-sch-veld')) {
      s.greep = nu.getAttribute('data-df-sch-veld');
    }
    return s;
  }

  function zetTerug(s) {
    if (!s || !s.label) return;
    var b = balk();
    if (!b) return;
    var raak = null;
    groepen().forEach(function (g) { if (!raak && labelVan(g) === s.label) raak = g; });
    if (!raak) return;
    raak.open = true;

    if (s.zoek) {
      var zoek = raak.querySelector('[data-df-zoek]');
      if (zoek) {
        zoek.value = s.zoek;
        zoek.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }
    var lijst = raak.querySelector('.df-fb__lijst');
    if (lijst) lijst.scrollTop = s.scroll;

    if (s.vink) {
      var doel = null;
      Array.prototype.forEach.call(raak.querySelectorAll('input[type="checkbox"]'), function (i) {
        if (!doel && i.name === s.vink.naam && i.value === s.vink.waarde) doel = i;
      });
      /* preventScroll, want anders springt de pagina alsnog naar het vinkje -
         precies wat we hier aan het voorkomen zijn. Oudere browsers negeren
         die optie; die krijgen geen focus in plaats van een sprong. */
      if (doel) {
        try { doel.focus({ preventScroll: true }); } catch (e) { /* laat maar */ }
      }
    }

    if (s.greep) {
      var greep = raak.querySelector('[data-df-sch-veld="' + s.greep + '"]');
      if (greep) {
        try { greep.focus({ preventScroll: true }); } catch (e) { /* laat maar */ }
      }
    }
  }

  /* ---------- ophalen en vervangen ---------- */

  var lopend = null;

  function vervang(id, html) {
    var doel = document.getElementById('shopify-section-' + id);
    if (!doel || !html) return;
    var vers = new DOMParser().parseFromString(html, 'text/html')
                              .getElementById('shopify-section-' + id);
    doel.innerHTML = vers ? vers.innerHTML : html;
  }

  function naarBovenGrid() {
    var doel = balk() || grid();
    if (!doel) return;
    var kop = document.querySelector('.hdr');
    var marge = (kop ? kop.getBoundingClientRect().height : 0) + 16;
    var y = window.pageYOffset + doel.getBoundingClientRect().top - marge;
    window.scrollTo({ top: Math.max(0, y), behavior: RUSTIG.matches ? 'auto' : 'smooth' });
  }

  function ga(adres, opties) {
    opties = opties || {};
    var b = balk();
    var g = grid();
    var ids = [sectieVan(b), sectieVan(g)].filter(Boolean);
    if (!ids.length || !window.fetch || !window.DOMParser) {
      window.location.href = adres;
      return;
    }

    var bewaard = standNu();
    if (g) g.setAttribute('aria-busy', 'true');

    /* Klikt iemand drie vinkjes achter elkaar, dan telt alleen de laatste. */
    if (lopend) lopend.abort();
    var af = ('AbortController' in window) ? new AbortController() : null;
    lopend = af;

    var scheiding = adres.indexOf('?') > -1 ? '&' : '?';
    fetch(adres + scheiding + 'sections=' + ids.join(','),
          af ? { signal: af.signal } : undefined)
      .then(function (r) {
        if (!r.ok) throw new Error('sectie niet opgehaald');
        return r.json();
      })
      .then(function (d) {
        lopend = null;
        ids.forEach(function (id) { vervang(id, d[id]); });
        merkJs();
        stelSchuivenIn();
        zetTerug(bewaard);
        var g2 = grid();
        if (g2) g2.removeAttribute('aria-busy');
        if (opties.push !== false) {
          window.history.pushState({ dfShop: 1 }, '', adres);
        }
        if (opties.naarBoven) naarBovenGrid();
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        /* Niet blijven hangen met een half scherm: dan maar op de gewone
           manier, precies zoals het zonder dit script zou gaan. */
        window.location.href = adres;
      });
  }

  /* ---------- wat we opvangen ---------- */

  function zonderPagina(u) {
    u.searchParams.delete('page');
    return u.pathname + (u.search || '');
  }

  document.addEventListener('change', function (e) {
    var el = e.target;
    var b = balk();
    if (!b || !el || !b.contains(el)) return;

    if (el.name === 'sort_by') {
      var u = new URL(window.location.href);
      if (el.value) u.searchParams.set('sort_by', el.value);
      else u.searchParams.delete('sort_by');
      ga(zonderPagina(u));
      return;
    }

    if (el.type === 'checkbox') {
      var naar = el.getAttribute('data-df-url');
      if (naar) ga(naar);
    }
  });

  /* De prijsvakken hebben geen eigen adres; die komen via het formulier
     binnen. Alle aangevinkte filters staan er als velden in, dus dit is
     dezelfde uitkomst als de gewone verzending - alleen zonder herladen. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    var b = balk();
    if (!b || !form || !b.contains(form)) return;
    e.preventDefault();
    var u = new URL(form.getAttribute('action') || window.location.pathname, window.location.origin);
    u.search = '';
    var velden = new FormData(form);
    velden.forEach(function (waarde, naam) {
      if (waarde !== '') u.searchParams.append(naam, waarde);
    });
    ga(u.pathname + (u.search || ''));
  });

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest ? e.target.closest('a[href]') : null;
    if (!a || a.target === '_blank' || a.hasAttribute('download')) return;

    var b = balk();
    var g = grid();
    var uitBalk = b && b.contains(a) &&
                  (a.classList.contains('df-fb__pil') ||
                   a.classList.contains('df-fb__wis') ||
                   a.classList.contains('df-fb__leegmaak'));
    var uitPaginering = g && g.contains(a) && !!a.closest('.df-pgr__pag');
    if (!uitBalk && !uitPaginering) return;

    e.preventDefault();
    /* Bij paginering hoor je wel bovenaan de nieuwe pagina te beginnen - daar
       is het juist verwarrend om halverwege een andere lijst te blijven staan. */
    ga(a.getAttribute('href'), { naarBoven: uitPaginering });
  });

  window.addEventListener('popstate', function () {
    if (!balk()) return;
    ga(window.location.href, { push: false });
  });

  document.addEventListener('shopify:section:load', function () {
    merkJs();
    stelSchuivenIn();
  });
  merkJs();
  stelSchuivenIn();
})();
